import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "oc-blank",
  "use": "oc-blank-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"oc-blank\"><path d=\"M426.666667 128v85.333333H213.333333v597.333334h597.333334v-213.333334h85.333333v256a42.666667 42.666667 0 0 1-42.666667 42.666667H170.666667a42.666667 42.666667 0 0 1-42.666667-42.666667V170.666667a42.666667 42.666667 0 0 1 42.666667-42.666667h256z m323.669333 85.333333H554.666667V128h341.333333v341.333333h-85.333333V273.664l-298.666667 298.666667L451.669333 512l298.666667-298.666667z\" p-id=\"2340\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol